<template>
  <div>
      <h1>VOCÊ SERÁ REDIRECIONADO...</h1>
  </div>
</template>

<script>
export default {
    name: 'sga',
    // components: { CardSeplag},    
    data: function(){
        return{
           
        }
    },  
    created() {
        window.location.href = process.env.VUE_APP_API_URL_SGA
    },

}
</script>

<style>

</style>